import { queryOptions, useQuery } from '@tanstack/react-query';
import { getGradesByCountry } from '@/app/(teacher)/profile/_actions/getGradesByCountry';
import type { Grade } from '@/app/(teacher)/profile/_actions/types';
import type { ServerActionResponse } from '@/features/server/actions/types';

export const GradesQuery = (selectedCountry = 'US') =>
  queryOptions({
    queryKey: ['grades', selectedCountry],
    queryFn: () => getGradesByCountry(selectedCountry),
    select: (data: ServerActionResponse<Grade[] | null>) => data?.data || [],
  });

export const useGrades = (selectedCountry = 'US') => useQuery(GradesQuery(selectedCountry));
